import { MGPFallible, Utils } from '@everyboard/lib';
import { MoveWithTwoCoords } from '../../jscaip/MoveWithTwoCoords';
import { TrexoFailure } from './TrexoFailure';
import { TrexoState } from './TrexoState';
/**
 * It's not really a move coord to coord but rather a "drop two coords" (that are neighbor)
 */
export class TrexoMove extends MoveWithTwoCoords {
    static encoder = MoveWithTwoCoords.getFallibleEncoder(TrexoMove.from);
    static from(zero, one) {
        Utils.assert(TrexoState.isOnBoard(zero), `${zero.toString()} is out of the TrexoBoard!`);
        Utils.assert(TrexoState.isOnBoard(one), `${one.toString()} is out of the TrexoBoard!`);
        const distance = zero.getOrthogonalDistance(one);
        if (distance === 1) {
            return MGPFallible.success(new TrexoMove(zero, one));
        }
        else {
            return MGPFallible.failure(TrexoFailure.NON_NEIGHBORING_SPACES());
        }
    }
    constructor(first, second) {
        super(first, second);
    }
    toString() {
        return this.getFirst().toString() + ' && ' + this.getSecond().toString();
    }
    equals(other) {
        return this.getFirst().equals(other.getFirst()) && this.getSecond().equals(other.getSecond());
    }
    getZero() {
        return this.getFirst();
    }
    getOne() {
        return this.getSecond();
    }
}
